
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.25 13.75v-5M3.75 10V8.75h5V10m3.124 2.5h4.375m-4.375-3.75h4.375M3.75 16.25h12.5M5 13.75h2.5","stroke":"#666","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.008 4.634a1.25 1.25 0 01.366.884v11.983a1.875 1.875 0 01-1.874 1.874h-15a1.876 1.876 0 01-1.876-1.874v-15A1.875 1.875 0 012.5.625h11.98a1.25 1.25 0 01.885.367l3.643 3.642z","stroke":"#666","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.374.625v3.75a1.25 1.25 0 001.25 1.25h3.75","stroke":"#666","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    